import { render } from "./notifications.vue?vue&type=template&id=bbf61e32&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"

import "./notifications.vue?vue&type=style&index=0&id=bbf61e32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bbf61e32"

export default script